import { RegularReservationSettingProps } from 'types/med'
import { isEqual } from 'lodash'

type ObjType = {
  [key: number]: RegularReservationSettingProps
}

const isEqualRegularReservationSettings: (
  a: RegularReservationSettingProps[],
  b: RegularReservationSettingProps[]
) => boolean = (a, b) => {
  const aObj: ObjType = {}
  const bObj: ObjType = {}
  a.forEach((data) => {
    aObj[data.day_of_week] = data
  })
  b.forEach((data) => {
    bObj[data.day_of_week] = data
  })
  return isEqual(aObj, bObj)
}

export default isEqualRegularReservationSettings
